export enum ServiceContractErrorOrigin {
    CREATE_SERVICE_CONTRACT = 'CREATE_SERVICE_CONTRACT',
    GET_SERVICE_CONTRACTS = 'GET_SERVICE_CONTRACTS',
    GET_CONTRACT_BY_ID = 'GET_CONTRACT_BY_ID',
    GET_SERVICE_CONTRACCT_DEBITS = 'GET_SERVICE_CONTRACCT_DEBITS',
    GET_CONTRACT_DEBIT_BY_ID = 'GET_CONTRACT_DEBIT_BY_ID',
    UPDATE_SERVICE_CONTRACT = 'UPDATE_SERVICE_CONTRACT',
    DELETE_SERVICE_CONTRACT_DEBIT = 'DELETE_SERVICE_CONTRACT_DEBIT',
}

export interface ServiceContractError {
    type: ServiceContractErrorOrigin,
    detail: any
}